var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProperties(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 18.334H18.3337",
    stroke: "#6F7A85",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45801 18.3324L2.49967 8.30739C2.49967 7.79905 2.74134 7.31577 3.14134 6.9991L8.97467 2.45742C9.57467 1.99076 10.4163 1.99076 11.0247 2.45742L16.858 6.99076C17.2663 7.30742 17.4997 7.79072 17.4997 8.30739V18.3324",
    stroke: "#6F7A85",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.8337 14.166H9.16699C8.47533 14.166 7.91699 14.7243 7.91699 15.416V18.3327H12.0837V15.416C12.0837 14.7243 11.5253 14.166 10.8337 14.166Z",
    stroke: "#6F7A85",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.91699 11.4577H6.25033C5.79199 11.4577 5.41699 11.0827 5.41699 10.6243V9.37435C5.41699 8.91602 5.79199 8.54102 6.25033 8.54102H7.91699C8.37533 8.54102 8.75033 8.91602 8.75033 9.37435V10.6243C8.75033 11.0827 8.37533 11.4577 7.91699 11.4577Z",
    stroke: "#6F7A85",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.75 11.4577H12.0833C11.625 11.4577 11.25 11.0827 11.25 10.6243V9.37435C11.25 8.91602 11.625 8.54102 12.0833 8.54102H13.75C14.2083 8.54102 14.5833 8.91602 14.5833 9.37435V10.6243C14.5833 11.0827 14.2083 11.4577 13.75 11.4577Z",
    stroke: "#6F7A85",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 5.83398L15.8083 3.33398H12.1416",
    stroke: "#6F7A85",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperties);
export default __webpack_public_path__ + "static/media/properties.daaa40b8fa67f35dbd1287dc89298e91.svg";
export { ForwardRef as ReactComponent };